import { TYPES } from "./appointment.actions";

export const initialState = {
    currentStep: 1,
    form: {
        step1: {
            part1: {
                adviser: {
                    code: "",
                    fullName: ""
                }
            }, 
            part2: {
                periodId: 0,
                duration: {
                    onlyDay: {
                        date: -1,
                        time: {
                            start: -1,
                            end: -1,
                            inactivity: [] //[{ start: -1, end: -1 }]
                        },
                    },
                    manyDays: {
                        date: {
                            start: -1,
                            end: -1
                        },
                        days: [],
                        time: [], 
                    }
                }
            }
        },
        step2: {
            part1: {
                locationId: 0,
                place: {
                    campus: {
                        id: 0,
                        name: ""
                    },
                    environment: {
                        envName: "",
                        address: "",
                        floor: ""
                    }
                }
            },
            part2: {
                publicLoad: {
                    students: {
                        publicByCampusIds: [],
                        modalityId: 0
                    }
                }
            }
        }
    },
    errors: {
        step1: {
            part1: {
                adviser: false
            }, 
            part2: {
                periodId: false,
                duration: {
                    onlyDay: {
                        date: false,
                        time: {
                            start: false,
                            end: false,
                            inactivity: []
                        },
                        areInvalidTimes: false
                    },
                    manyDays: {
                        date: {
                            start: false, 
                            end: false, 
                        }, 
                        areInvalidDates: false, 
                        days: false, 
                        time: []
                        /*
                        [
                            { 
                                dayId: 0, 
                                start: false, 
                                end: false,
                                areInvalidTimes: false,
                                inactivity: [
                                    {
                                        time: {
                                            start: false,
                                            end: false
                                            areInvalidTimes: false
                                        },
                                        date: false
                                    }
                                ]
                            }
                        ],
                        */
                    }
                }
            }
        },
        step2: {
            part1: {
                locationId: false,
                place: {
                    campus: false,
                    environment: {
                        envName: false,
                        floor: false
                    }
                }
            },
            part2: {
                publicLoad: {
                    students: {
                        publicByCampusIds: false,
                        modalityId: false
                    }
                }
            }
        }
    },
    errorTexts: {
        adviser: ""
    }
};
//#region Functions
const changeFieldForm = (
    prev, step, 
    {  
        part, field, 
        value, errorValue = null 
    }) => {
    const obj = errorValue === null ? {} : {
        [field]: errorValue
    };
    return {
        ...prev, 
        form: {
            ...prev.form, 
            [step]: {
                ...prev.form[step], 
                [part]: {
                    ...prev.form[step][part], 
                    [field]: value
                }
            }
        },
        errors: {
            ...prev.errors,
            [step]: {
                ...prev.errors[step],
                [part]: {
                    ...prev.errors[step][part],
                    ...obj
                }
            }
        }
    };
}
const changeErrorFormForStep = (prev, step, value) => {
    return {
        ...prev,
        errors: {
            ...prev.errors, 
            [step]: value
        }
    }
}
const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
//#endregion

const reducer = (state, action) => {
    switch (action.type) {
        case TYPES.NEXT_STEP: 
            return { 
                ...state, 
                currentStep: state.currentStep + 1
            };
        case TYPES.BACK_STEP: 
            return { 
                ...state, 
                currentStep: state.currentStep - 1
            };
        case TYPES.TO_STEP: 
            scrollToTop();
            return {
                ...state,
                currentStep: action.payload.step
            };
        case TYPES.SET_FORM_STEP_1: 
            return changeFieldForm(
                state, "step1", 
                action.payload.entries);
        case TYPES.SET_FORM_STEP_2: 
            return changeFieldForm(
                state, "step2", 
                action.payload.entries);
        case TYPES.SET_FORM_ERRORS_STEP_1:
            return changeErrorFormForStep(
                state, "step1", 
                action.payload.value);
        case TYPES.SET_FORM_ERRORS_STEP_2:
            return changeErrorFormForStep(
                state, "step2", 
                action.payload.value);
        case TYPES.SET_ERROR_TEXT:
            const { field, text } = action.payload;
            return {
                ...state, 
                errorTexts: {
                    [field]: text
                }
            };
        default: 
            return state;
    }
}

export default reducer;